import { render, staticRenderFns } from "./ReviewChat.vue?vue&type=template&id=e1bc853a&"
import script from "./ReviewChat.vue?vue&type=script&lang=ts&"
export * from "./ReviewChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports